// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantitySelector_quantitySelector__rTfnu {
  display: flex;
  align-items: center;
}

.quantitySelector_controls__WVnj5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 0.2rem;
  padding-left: 0.5rem;
}

.quantitySelector_decrease_button__Suulm {
  background-color: #e12c4f;
}

.quantitySelector_increase_button__7G8M6 {
  background-color: #028b81;
}

.quantitySelector_decrease_button__Suulm,
.quantitySelector_increase_button__7G8M6 {
  color: #fff;
  border: none;
  border-radius: 3px;
  width: 20px;
  height: 13px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quantitySelector_increase_button__container__TVjBS {
  padding-bottom: 0.1rem;
}

.quantitySelector_inputGroup__\\+iABH {
  display: flex;
  align-items: center;
}

.quantitySelector_quantityInput__Rhd9z,
.quantitySelector_maxQuantityInput__FFSSc {
  max-width: 2.5rem;
  border-radius: 3px;
  border: 1px solid #c2c2c2;
  text-align: right;
  padding: 0.2rem;
}

.quantitySelector_separator__aV7gd {
  padding: 0 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/QuantitySelector/quantitySelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".quantitySelector {\n  display: flex;\n  align-items: center;\n}\n\n.controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-right: 0.2rem;\n  padding-left: 0.5rem;\n}\n\n.decrease_button {\n  background-color: #e12c4f;\n}\n\n.increase_button {\n  background-color: #028b81;\n}\n\n.decrease_button,\n.increase_button {\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  width: 20px;\n  height: 13px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.increase_button__container {\n  padding-bottom: 0.1rem;\n}\n\n.inputGroup {\n  display: flex;\n  align-items: center;\n}\n\n.quantityInput,\n.maxQuantityInput {\n  max-width: 2.5rem;\n  border-radius: 3px;\n  border: 1px solid #c2c2c2;\n  text-align: right;\n  padding: 0.2rem;\n}\n\n.separator {\n  padding: 0 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quantitySelector": `quantitySelector_quantitySelector__rTfnu`,
	"controls": `quantitySelector_controls__WVnj5`,
	"decrease_button": `quantitySelector_decrease_button__Suulm`,
	"increase_button": `quantitySelector_increase_button__7G8M6`,
	"increase_button__container": `quantitySelector_increase_button__container__TVjBS`,
	"inputGroup": `quantitySelector_inputGroup__+iABH`,
	"quantityInput": `quantitySelector_quantityInput__Rhd9z`,
	"maxQuantityInput": `quantitySelector_maxQuantityInput__FFSSc`,
	"separator": `quantitySelector_separator__aV7gd`
};
export default ___CSS_LOADER_EXPORT___;
